export default __webpack_public_path__ + "images/models/da2dd68a0b1f7cfd81b8a506e1b04d31.glb";